import type { Project } from '~/types/next-auth';

export function hasEfacilAndMartinsAdsProjects(
  projects: Project[] | null | undefined
): boolean {
  if (!projects || projects.length !== 2) {
    return false;
  }

  const projectNames = projects.map(project =>
    project.projectName.toUpperCase()
  );

  return projectNames.includes('EFACIL') && projectNames.includes('MARTINSADS');
}
